import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <Router>
        <Routes />
      </Router>
      <ToastContainer theme="dark" />
    </>
  );
}

export default App;
